// extracted by mini-css-extract-plugin
export default {"frame-overlay":"styles_frame-overlay__XPpy2"};